import type { GridApi, GridColDef, GridSortModel } from '@mui/x-data-grid-pro';
import { DataGridPro, useGridApiRef } from '@mui/x-data-grid-pro';
import { Stack } from '@src/common/components/Stack';
import { tableStyle } from '@src/common/components/tableStyle/TableStyle';
import { theme } from '@src/common/styles/Theme';
import { sortingModeAssembler } from '@src/permits/permitSearch/SortingModeAssembler';
import { useTranslation } from 'react-i18next';

interface Props {
  isLoading: boolean;
  onSortModelChange: (sortModel: GridSortModel) => void;
  sortModel: GridSortModel;
  columns: GridColDef[];
  rows: object[];
  apiRef?: React.MutableRefObject<GridApi>;
}

export const PermitTable = ({
  isLoading,
  onSortModelChange,
  sortModel,
  columns,
  rows,
  apiRef: externalApiRef,
}: Props) => {
  const { t } = useTranslation();
  const internalApiRef = useGridApiRef();
  const apiRef = externalApiRef || internalApiRef;

  return (
    <Stack minHeight="235px" flex="1" paddingTop={theme.spacing['5']}>
      <DataGridPro
        apiRef={apiRef}
        aria-label={t('permitSearch.table')}
        columns={columns}
        rows={rows}
        sortingMode={sortingModeAssembler(sortModel)}
        sortModel={sortModel}
        onSortModelChange={onSortModelChange}
        paginationMode="client"
        className={tableStyle}
        hideFooterRowCount
        hideFooterSelectedRowCount
        disableColumnFilter
        disableColumnMenu
        loading={isLoading}
        localeText={{
          noRowsLabel: t('permitSearch.noResults'),
        }}
      />
    </Stack>
  );
};
